import { Pipe, PipeTransform, inject } from '@angular/core';
import { FormattingOverrides } from '@zag/core/common';
import { FormattingService } from './formatting.service';

/**
 * Formats a date-time value using the active locale-aware formatting context.
 *
 * Usage:
 * ```html
 * {{ myDate | zagDateTime }}
 * {{ myDate | zagDateTime : { timeZone: 'UTC' } }}
 * ```
 */
@Pipe({
  name: 'zagDateTime',
  pure: false,
})
export class ZagDateTimePipe implements PipeTransform {
  private readonly formattingService = inject(FormattingService);

  transform(value: Date | string | number | null | undefined, overrides?: FormattingOverrides): string {
    if (value == null) {
      return '';
    }
    return this.formattingService.formatDateTime(value, overrides);
  }
}
